<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="x-SECTION-BREAK"> </p>
<p class="x1CHAP-NUM">CONTENTS</p>
<div id="toc_marker-1"><p class="x2TOC-AFTER-TXB1"><span class="Italic"><span href="#/Dedication#toc_marker-1" title="Link target outside of Sample">Dedication</span></span></p></div>
<div id="toc_marker-3"><p class="x2TOC-AFTER-TXB1"><a href="#/Prologue#toc_marker-3">Prologue</a></p></div>
<div id="toc_marker-4"><p class="x2TOC"><a href="#/Part1#toc_marker-4">Part 1</a></p></div>
<div id="toc_marker-5"><p class="x2TOC"><a href="#/Chapter1#toc_marker-5">Chapter 1</a></p></div>
<div id="toc_marker-6"><p class="x2TOC"><a href="#/Chapter2#toc_marker-6">Chapter 2</a></p></div>
<div id="toc_marker-7"><p class="x2TOC"><a href="#/Chapter3#toc_marker-7">Chapter 3</a></p></div>
<div id="toc_marker-8"><p class="x2TOC"><a href="#/Chapter4#toc_marker-8">Chapter 4</a></p></div>
<div id="toc_marker-9"><p class="x2TOC"><a href="#/Chapter5#toc_marker-9">Chapter 5</a></p></div>
<div id="toc_marker-10"><p class="x2TOC"><a href="#/Chapter6#toc_marker-10">Chapter 6</a></p></div>
<div id="toc_marker-11"><p class="x2TOC"><a href="#/Chapter7#toc_marker-11">Chapter 7</a></p></div>
<div id="toc_marker-12"><p class="x2TOC"><a href="#/Chapter8#toc_marker-12">Chapter 8</a></p></div>
<div id="toc_marker-13"><p class="x2TOC"><a href="#/Chapter9#toc_marker-13">Chapter 9</a></p></div>
<div id="toc_marker-14"><p class="x2TOC"><a href="#/Chapter10#toc_marker-14">Chapter 10</a></p></div>
<div id="toc_marker-15"><p class="x2TOC"><a href="#/Chapter11#toc_marker-15">Chapter 11</a></p></div>
<div id="toc_marker-16"><p class="x2TOC"><a href="#/Chapter12#toc_marker-16">Chapter 12</a></p></div>
<div id="toc_marker-17"><p class="x2TOC"><a href="#/Chapter13#toc_marker-17">Chapter 13</a></p></div>
<div id="toc_marker-18"><p class="x2TOC"><a href="#/Chapter14#toc_marker-18">Chapter 14</a></p></div>
<div id="toc_marker-19"><p class="x2TOC"><a href="#/Chapter15#toc_marker-19">Chapter 15</a></p></div>
<div id="toc_marker-20"><p class="x2TOC"><a href="#/Chapter16#toc_marker-20">Chapter 16</a></p></div>
<div id="toc_marker-21"><p class="x2TOC"><a href="#/Chapter17#toc_marker-21">Chapter 17</a></p></div>
<div id="toc_marker-22"><p class="x2TOC"><a href="#/Chapter18#toc_marker-22">Chapter 18</a></p></div>
<div id="toc_marker-23"><p class="x2TOC"><a href="#/Chapter19#toc_marker-23">Chapter 19</a></p></div>
<div id="toc_marker-24"><p class="x2TOC"><a href="#/Chapter20#toc_marker-24">Chapter 20</a></p></div>
<div id="toc_marker-25"><p class="x2TOC"><a href="#/Chapter21#toc_marker-25">Chapter 21</a></p></div>
<div id="toc_marker-26"><p class="x2TOC"><a href="#/Chapter22#toc_marker-26">Chapter 22</a></p></div>
<div id="toc_marker-27"><p class="x2TOC"><a href="#/Part2#toc_marker-27">Part 2</a></p></div>
<div id="toc_marker-28"><p class="x2TOC"><span class="Italic"><span href="#/Interlude#toc_marker-28" title="Link target outside of Sample">["This is not what you . . ."]</span></span></p></div>
<div id="toc_marker-29"><p class="x2TOC"><a href="#/Chapter23#toc_marker-29">Chapter 23</a></p></div>
<div id="toc_marker-30"><p class="x2TOC"><a href="#/Chapter24#toc_marker-30">Chapter 24</a></p></div>
<div id="toc_marker-31"><p class="x2TOC"><a href="#/Chapter25#toc_marker-31">Chapter 25</a></p></div>
<div id="toc_marker-32"><p class="x2TOC"><a href="#/Chapter26#toc_marker-32">Chapter 26</a></p></div>
<div id="toc_marker-33"><p class="x2TOC"><a href="#/Chapter27#toc_marker-33">Chapter 27</a></p></div>
<div id="toc_marker-34"><p class="x2TOC"><a href="#/Chapter28#toc_marker-34">Chapter 28</a></p></div>
<div id="toc_marker-35"><p class="x2TOC"><a href="#/Chapter29#toc_marker-35">Chapter 29</a></p></div>
<div id="toc_marker-36"><p class="x2TOC"><a href="#/Chapter30#toc_marker-36">Chapter 30</a></p></div>
<div id="toc_marker-37"><p class="x2TOC"><a href="#/Chapter31#toc_marker-37">Chapter 31</a></p></div>
<div id="toc_marker-38"><p class="x2TOC"><a href="#/Chapter32#toc_marker-38">Chapter 32</a></p></div>
<div id="toc_marker-39"><p class="x2TOC"><a href="#/Chapter33#toc_marker-39">Chapter 33</a></p></div>
<div id="toc_marker-40"><p class="x2TOC"><a href="#/Chapter34#toc_marker-40">Chapter 34</a></p></div>
<div id="toc_marker-41"><p class="x2TOC"><a href="#/Chapter35#toc_marker-41">Chapter 35</a></p></div>
<div id="toc_marker-42"><p class="x2TOC"><a href="#/Chapter36#toc_marker-42">Chapter 36</a></p></div>
<div id="toc_marker-43"><p class="x2TOC"><a href="#/Chapter37#toc_marker-43">Chapter 37</a></p></div>
<div id="toc_marker-44"><p class="x2TOC"><a href="#/Chapter38#toc_marker-44">Chapter 38</a></p></div>
<div id="toc_marker-45"><p class="x2TOC"><a href="#/Chapter39#toc_marker-45">Chapter 39</a></p></div>
<div id="toc_marker-46"><p class="x2TOC"><a href="#/Chapter40#toc_marker-46">Chapter 40</a></p></div>
<div id="toc_marker-47"><p class="x2TOC"><a href="#/Chapter41#toc_marker-47">Chapter 41</a></p></div>
<div id="toc_marker-48"><p class="x2TOC"><span href="#/Epilogue#toc_marker-48" title="Link target outside of Sample">Epilogue</span></p></div>
<div id="toc_marker-49"><p class="x2TOC-AFTER-TXB1"><span class="Italic"><a href="#/AbouttheAuthor#toc_marker-49">About the Author</a></span></p></div>
<div id="naann"><p class="x2TOC"><span href="#/Abyss_Announcement#aann" title="Link target outside of Sample"><span class="Italic">An Excerpt from</span> OF THE DIVINE</span></p></div>
<div id="napa3"><p class="x2TOC"><span class="Italic"><span href="#/Abyss_Part_1#apa3" title="Link target outside of Sample">Part 1</span></span> </p></div>
<div id="nach4"><p class="x2TOC"><span class="Italic"><span href="#/Abyss_Chapter_1#ach4" title="Link target outside of Sample">Chapter 1</span></span> </p></div>
<div id="toc_marker-50"><p class="x2TOC"><span class="Italic"><a href="#/AlsobytheAuthor#toc_marker-50">Young Adult Novels by Amelia Atwater-Rhodes</a></span></p></div>
<div id="toc_marker-51"><p class="x2TOC"><span class="Italic"><span href="#/Copyright#toc_marker-51" title="Link target outside of Sample">Copyright</span></span></p></div>
<div id="toc_marker-52"><p class="x2TOC"><span class="Italic"><a href="#/AboutthePublisher#toc_marker-52">About the Publisher</a></span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3b483a88